// import Category from './Category';

export default {
  // component: Category,
  component: load(() =>
    import(/* webpackChunkName: "Bulletin-Category" */ "./Category")
  ),
  priority: 9,
  permissions: [
    "BasicInformationMenu/GroupMenu"],
  name: app.translate("گروه‌ها"),
  icon: "tag",
  drawer: true,
  description: `گروه: در نرم افزار حضور غیاب رادن منظور از گروه ، کارگروه های موقت یا پروژه هایی هستند که به مدت محدودی از دپارتمان های مختلف به منظور خاصی ایجاد و بعد از اتمام زمان منحل می گردند . چنانچه در این بازه زمانی قوانین ساعت کار و ضرایب اضافه کار ، کسر کار و ... متفاوت باشند ، می توان قوانین خاصی را برای این برهه از زمان برای این افراد در نظر گرفت.
با استفاده از این ماژول شما می توانید هر فرد را در یک گروه قرار دهید و در زمان تهیه گزارشات بجای استفاده از چارت، از گروه مورد نظر گزارشات را تهیه کنید.`,
};
